import { useEffect, useState } from 'react';
import { formatDurationNumerical } from 'utils/formatUtils';

export const useStopwatch = ({
  initialDate,
  showHours = true,
}: { initialDate?: Date; showHours?: boolean } = {}) => {
  const [timePassed, setTimePassed] = useState(() => {
    if (!initialDate) return 0;
    const now = new Date();
    return Math.floor((now.getTime() - initialDate.getTime()) / 1000);
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setTimePassed((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return {
    timePassed,
    formattedTime: formatDurationNumerical(timePassed, { showHours }),
  };
};
